export default{
    apiKey: "AIzaSyDHf_7XqTG0BBenXVffh1azqNWQuWUd0m4",
    authDomain: "talkii-86070.firebaseapp.com",
    databaseURL: "https://talkii-86070.firebaseio.com",
    projectId: "talkii-86070",
    storageBucket: "talkii-86070.appspot.com",
    messagingSenderId: "518085462250",
    appId: "1:518085462250:web:47c26114daae0cafe52f93",
    measurementId: "G-WJZQSPLN96"  
}